<template>
  <v-footer padless>
    <v-bottom-navigation
      grow
      flat
      fixed
      height="59"
      id="footer-nav"
      v-model="value"
    >
      <!-- grow
          flat -->
      <div class="footer-container">
        <v-btn @click="clickEventHome()">
          <img
            :src="
              isHomeNavActive
                ? require('@/assets/img/icons/entrySelected.png')
                : require('@/assets/img/icons/entries.png')
            "
            height="23px"
            width="23px"
            loading="eager"
          />
        </v-btn>

        <v-btn @click="clickEventNotifications()" style="background:white;">
          <v-badge overlap color="red" :content="badge" :value="badge">
            <img
              :src="
                isNotificationNavActive
                  ? require('@/assets/img/icons/notificationSelected.png')
                  : require('@/assets/img/icons/notifications.png')
              "
              height="23px"
              width="22px"
              style="margin-bottom:-2px;"
              loading="eager"
            />
          </v-badge>
        </v-btn>

        <v-btn @click="clickEventProfile()">
          <img
            :src="
              isProfileNavActive
                ? require('@/assets/img/icons/configuratorSelected.png')
                : require('@/assets/img/icons/config.png')
            "
            height="23"
            width="23"
            loading="eager"

          />
        </v-btn>
      </div>
    </v-bottom-navigation>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainFooter',
  props: {
    isHomeNavActive: Boolean,
    isNotificationNavActive: Boolean,
    isProfileNavActive: Boolean,
    clickEventHome: Function,
    clickEventNotifications: Function,
    clickEventProfile: Function
  },
  data: () => ({
    value: 'home'
  }),
  computed: {
    ...mapGetters(['getBadgeNotif']),
    badge () {
      return this.getBadgeNotif
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footer/index.vue